import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 101 100"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g clip-path=\"url(#a)\"><path fill=\"#07F\" d=\"M.5 48c0-22.627 0-33.941 7.03-40.97C14.558 0 25.872 0 48.5 0h4c22.627 0 33.941 0 40.97 7.03 7.03 7.029 7.03 18.343 7.03 40.97v4c0 22.627 0 33.941-7.03 40.97C86.442 100 75.128 100 52.5 100h-4c-22.627 0-33.941 0-40.97-7.03C.5 85.942.5 74.628.5 52z\"></path><path fill=\"#fff\" d=\"M53.709 72.042c-22.792 0-35.792-15.625-36.334-41.625h11.417C29.167 49.5 37.583 57.584 44.25 59.25V30.417H55v16.458c6.584-.708 13.5-8.208 15.833-16.458h10.75c-1.791 10.167-9.291 17.667-14.625 20.75 5.334 2.5 13.876 9.042 17.126 20.875H72.25C69.708 64.125 63.375 58 55 57.167v14.875z\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M.5 0h100v100H.5z\"></path></clipPath></defs>", 2)
  ])))
}
export default { render: render }